<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close(false)">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("guest") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <!-- <v-card-title class="mx-12 mt-4">{{ $t("guest_login") }}</v-card-title> -->

      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-list-item>
              <v-text-field
                v-model="phone"
                :rules="[inputRules.required, inputRules.phone]"
                :label="$t('phone')"
                required
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-text-field v-model="name" :label="$t('contact_name')"></v-text-field>
            </v-list-item>

            <v-btn class="horizontal-center confirm-button" :disabled="!valid" @click="confirm">{{
              $t("confirm")
            }}</v-btn>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    valid: false,

    phone: "",
    name: "",

    /*
    phoneRules: [
      (v) => !!v || "Phone is required",
      (v) => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || "Phone must be valid",
    ],
    */
  }),

  methods: {
    async open() {
      this.dialog = true;

      let lastLogin = await this.getLastLogin();
      if (lastLogin != null) {
        this.phone = lastLogin.phone1;
        this.name = lastLogin.name;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close(result) {
      if (result) {
        this.$store.state.guest.phone1 = this.phone;
        this.$store.state.guest.name = this.name;

        this.updateOrderLogin(false);
        this.setLastLogin({
          name: this.$store.state.guest.name,
          phone1: this.$store.state.guest.phone1,
          isMember: false,
        });
      }
      this.$refs.form.reset();
      this.dialog = false;
      this.resolve(result);
    },

    async confirm() {
      let canClose = false;
      if (this.$store.state.verifyPhoneNumber) {
        let phoneID = "+1" + this.phone.replace(/\D+/g, "");
        let isVerifiedPhoneNumber = await this.isVerifiedPhoneNumber(phoneID);
        if (isVerifiedPhoneNumber) {
          this.$store.state.guest.phoneVerified = true;

          canClose = true;
        } else {
          isVerifiedPhoneNumber = await this.$root.phoneVerificationDialog(phoneID);
          if (isVerifiedPhoneNumber) {
            this.addVerifiedPhoneNumber(phoneID);
            this.$store.state.guest.phoneVerified = true;

            canClose = true;
          }
        }
      } else {
        this.$store.state.guest.phoneVerified = false;

        canClose = true;
      }

      if (canClose) {
        this.close(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-button {
  margin-top: 10px;
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}

.theme--light.v-btn.v-btn--disabled.confirm-button {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}
</style>
